import React, { useEffect } from "react";
import { Paper, Typography, Grid, Button, Box, Divider } from "@mui/material";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import CheckIcon from "@mui/icons-material/Check";
import "./UserProfileView.scss";

const UserProfileView = ({ onEdit, userProfileDetails, isEditMode }) => {
  const profile = userProfileDetails || [];
  const isBillingSame = profile.billingSameAsPermanent;

  // Remove id from both
  const permanentAddress = profile.permanentAddress
    ? Object.fromEntries(
        Object.entries(profile.permanentAddress).filter(([key]) => key !== "id")
      )
    : {};

  const billingAddress = profile.billingAddress
    ? Object.fromEntries(
        Object.entries(profile.billingAddress).filter(([key]) => key !== "id")
      )
    : {};

  // Extract basic info safely
  const firstName = profile.first_name || "";
  const lastName = profile.last_name || "";
  const email = profile.email || "";
  const phone = profile.mobileNumber || "";
  const funeralDirector = profile.isFuneralDirector ? "Yes" : "No";

  useEffect(() => {}, [isEditMode]);

  return (
    <Paper className="user-profile-view">
      {/* Header */}
      <Box className="user-profile-view__header">
        <Box className="user-profile-view__header-left">
          <Typography variant="h5" className="user-profile-view__user-name">
            {firstName} {lastName}
          </Typography>
          <Typography
            variant="h5"
            className="user-profile-view__user-profile-text"
          >
            User Profile
          </Typography>
        </Box>

        <Button
          onClick={onEdit}
          className="user-profile-view__edit-btn"
          startIcon={<ModeOutlinedIcon />}
        >
          Edit Profile
        </Button>
      </Box>
      <Divider />

      {/* Basic Information */}
      <Box className="user-profile-view__section">
        <Typography variant="h6" className="user-profile-view__section-title">
          Basic Information
        </Typography>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <p className="user-profile-view__label">First Name</p>
            <p className="user-profile-view__value">{firstName || "-"}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="user-profile-view__label">Last Name</p>
            <p className="user-profile-view__value">{lastName || "-"}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="user-profile-view__label">Email Address</p>
            <p className="user-profile-view__value">{email || "-"}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="user-profile-view__label">Phone Number</p>
            <p className="user-profile-view__value">{phone || "-"}</p>
          </Grid>
            <Grid item xs={12} sm={6}>
            <p className="user-profile-view__label">Funeral Director</p>
            <p className="user-profile-view__value">{funeralDirector || "-"}</p>
          </Grid>
        </Grid>
      </Box>
      <Divider />

      {/* Permanent Address */}
      <Box className="user-profile-view__section">
        <Typography variant="h6" className="user-profile-view__section-title">
          Permanent Address
        </Typography>

        {Object.keys(permanentAddress).length > 0 ? (
          <Grid container spacing={1}>
            {Object.entries(permanentAddress).map(([key, value]) => (
              <Grid key={key} item xs={12} sm={6}>
                <p className="user-profile-view__label">
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </p>
                <p className="user-profile-view__value">{value || "-"}</p>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography className="user-profile-view__no-data">
            No permanent address available
          </Typography>
        )}
      </Box>
      <Divider />

      {/* Billing Address */}
      <Box className="user-profile-view__section">
        <Box className="user-profile-view__section-header">
          <Typography variant="h6" className="user-profile-view__section-title">
            Billing Address
          </Typography>
        </Box>

        {isBillingSame && Object.keys(permanentAddress).length > 0 && (
          <Typography className="user-profile-view__same-text">
            <CheckIcon fontSize="small" sx={{ color: "#00786F" }} /> Billing
            address is same as permanent address
          </Typography>
        )}

        {Object.keys(billingAddress).length > 0 ? (
          <Grid container spacing={1}>
            {Object.entries(billingAddress).map(([key, value]) => (
              <Grid key={key} item xs={12} sm={6}>
                <p className="user-profile-view__label">
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </p>
                <p className="user-profile-view__value">{value || "-"}</p>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography className="user-profile-view__no-data">
            {isBillingSame
              ? "Billing address is same as permanent address"
              : "No billing address available"}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default UserProfileView;
